import React from "react";
import Card from "./Card";
import Icon from "./Icon";
import { formatCurrency, formatDelta, formatNumber, formatPercent } from "../../utils/format";

export function StatCard({ stat }) {
  if (!stat) return null;

  const trend = stat.trend || (stat.delta >= 0 ? "up" : "down");
  const valueText = stat.isCurrency ? formatCurrency(stat.value) : formatNumber(stat.value);
  const deltaPercent = typeof stat.deltaPercent === "number" ? formatPercent(stat.deltaPercent) : null;
  const deltaText = deltaPercent ? `${formatDelta(stat.delta)} • ${deltaPercent}` : formatDelta(stat.delta);

  return (
    <Card className="stat-card">
      <div className="stat-card-row">
        <div className="stat-meta">
          <div className="stat-label">{stat.label}</div>
          <div className="stat-value">{valueText}</div>
          {/* <div className={`stat-delta ${trend}`}>
            <span>{deltaText}</span>
            <span className="soft">vs last month</span>
          </div> */}
        </div>
        <div className="stat-icon" aria-hidden="true">
          <Icon name={stat.icon} size={24} />
        </div>
      </div>
    </Card>
  );
}

export default StatCard;
